import type { FacilityWorkflowRunPayload } from '@Application/WorkflowRuns/FacilityWorkflowRuns/Actions/facilityWorkflowRunsFetched';

/** The server answers with the supervision row, so the list refreshes without a second round-trip. */
export type WorkflowRunHandledAction = {
	type: 'WORKFLOW_RUN_HANDLED';
	payload: FacilityWorkflowRunPayload;
	facilityId: number;
	subjectId: number;
};

export default (
	payload: FacilityWorkflowRunPayload,
	facilityId: number,
	subjectId: number,
): WorkflowRunHandledAction => ({
	type: 'WORKFLOW_RUN_HANDLED',
	payload,
	facilityId,
	subjectId,
});
